import {motion} from 'framer-motion';
import Card from "../shared/Card";
import GeneralContext from '../../context/GeneralContext';
import { useContext } from 'react';
import ButtonFunction from '../shared/ButtonFunction';
import { useNavigate } from 'react-router-dom';

function AdminWelcome() {

    const { userName, changeCurrentMenu } = useContext(GeneralContext);

    const navigate = useNavigate();

    const toRoutingFunction = () => {
      navigate('/admin-user');
    }

    return (
      <motion.div
        key='adminUserWelcome'
        initial={{opacity: 0, x: -1000}}
        animate={{opacity: 1, x: 0}}
        exit={{opacity: 0, x: -1000, transition:{duration: 0.5, delay: 0}}}
        transition={{duration: 0.5}}>
          <Card>
              <h1>Te damos la bienvenida, {userName}</h1>
              <ButtonFunction
              buttonFunction={changeCurrentMenu}
              buttonArguments={'reset'}
              buttonClass='adminButton'
            >
              Restablecer contraseña
            </ButtonFunction>
            <br />
            <br />
            <ButtonFunction
              buttonFunction={toRoutingFunction}
              buttonClass='adminButton'
            >
              Volver a selección de modo
            </ButtonFunction>
          </Card>
        </motion.div>
    )
}

export default AdminWelcome